import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IHiddenPage } from "../models/HiddenPages";

// If you already have a standard response wrapper type, swap this to it.
export interface IHiddenPagesResponse {
  success: boolean;
  message: string;
  data: IHiddenPage[];
}

export default function useHiddenPages() {
  const { get } = useApiHelper();

  const hiddenPages = useQuery({
    queryKey: ["hiddenPages"],
    queryFn: () => get<IHiddenPagesResponse>("/hiddenpages"),
    refetchInterval: 1000 * 10,
  });

  return { hiddenPages };
}
